import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-[#05070a] py-12 border-t border-white/5 text-center" data-id="element-69">
        <div className="container mx-auto px-4" data-id="element-70">
          <div className="font-heading font-bold text-2xl text-white tracking-wider mb-4 opacity-50" data-id="element-71">
            NASDAQ<span className="text-trading-gold" data-id="element-72">PRO</span>
          </div>
          <p className="text-slate-500 text-sm max-w-2xl mx-auto mb-6" data-id="element-73">
            El trading conlleva un alto nivel de riesgo. Los resultados pasados
            no garantizan resultados futuros. Este material es estrictamente
            educativo.
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-74">
            <button onClick={() => setActiveModal('privacy')} className="text-slate-400 text-sm hover:text-trading-gold transition-colors underline underline-offset-4 decoration-slate-600 hover:decoration-trading-gold" data-id="element-75">
              Política de Privacidad
            </button>
            <span className="w-1 h-1 bg-slate-600 rounded-full" data-id="element-76" />
            <button onClick={() => setActiveModal('terms')} className="text-slate-400 text-sm hover:text-trading-gold transition-colors underline underline-offset-4 decoration-slate-600 hover:decoration-trading-gold" data-id="element-77">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-slate-600 text-xs" data-id="element-78">
            &copy; {new Date().getFullYear()} NASDAQ PRO. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Legal Modal */}
      <AnimatePresence data-id="element-79">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-80">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-81" />

            {/* Modal Content */}
            <motion.div initial={{
          opacity: 0,
          y: 30,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative bg-trading-card border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] shadow-2xl overflow-hidden" data-id="element-82">
              {/* Header */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 bg-trading-dark/50" data-id="element-83">
                <h3 className="font-heading text-xl text-white" data-id="element-84">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-slate-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/10" data-id="element-85">
                  <XIcon className="w-5 h-5" data-id="element-86" />
                </button>
              </div>

              {/* Body */}
              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-sm text-slate-300 leading-relaxed space-y-4" data-id="element-87">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-88" /> : <TermsContent data-id="element-89" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-90">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="font-heading text-lg text-white mt-4" data-id="element-91">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-92">
        Recopilamos información personal que usted nos proporciona directamente
        al realizar una compra, como su nombre, dirección de correo electrónico
        e información de pago. No almacenamos datos de tarjetas de crédito;
        estos son procesados de forma segura por nuestro proveedor de pagos.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-93">
        2. Uso de la Información
      </h4>
      <p data-id="element-94">
        Utilizamos su información personal para: procesar sus transacciones,
        enviarle el producto digital adquirido, comunicarnos con usted sobre su
        compra y mejorar nuestros productos y servicios.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-95">
        3. Protección de Datos
      </h4>
      <p data-id="element-96">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-97">4. Cookies</h4>
      <p data-id="element-98">
        Nuestro sitio web puede utilizar cookies para mejorar su experiencia de
        navegación y analizar el tráfico del sitio. Puede configurar su
        navegador para rechazar cookies, aunque esto podría afectar la
        funcionalidad del sitio.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-99">5. Terceros</h4>
      <p data-id="element-100">
        No vendemos, comercializamos ni transferimos su información personal a
        terceros, excepto a proveedores de servicios de confianza que nos
        asisten en la operación de nuestro sitio web y la entrega de productos,
        siempre que dichas partes acuerden mantener esta información
        confidencial.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-101">6. Sus Derechos</h4>
      <p data-id="element-102">
        Usted tiene derecho a acceder, rectificar o eliminar sus datos
        personales en cualquier momento. Para ejercer estos derechos, puede
        comunicarse con nosotros a través de los canales disponibles en nuestro
        sitio.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-slate-400 text-xs" data-id="element-103">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="font-heading text-lg text-white mt-4" data-id="element-104">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-105">
        Al acceder y utilizar este sitio web y adquirir nuestros productos
        digitales, usted acepta estar sujeto a estos Términos y Condiciones. Si
        no está de acuerdo con alguna parte de estos términos, no debe utilizar
        nuestro sitio ni adquirir nuestros productos.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-106">
        2. Naturaleza del Producto
      </h4>
      <p data-id="element-107">
        Este es un producto digital de carácter educativo. El contenido
        proporcionado es estrictamente informativo y no constituye asesoramiento
        financiero, de inversión ni de trading. Las estrategias presentadas son
        de naturaleza educativa y su aplicación es responsabilidad exclusiva del
        usuario.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-108">3. Riesgo de Trading</h4>
      <p data-id="element-109">
        El trading de futuros e instrumentos financieros conlleva un alto nivel
        de riesgo y puede no ser adecuado para todos los inversores. Existe la
        posibilidad de que usted pierda parte o la totalidad de su inversión
        inicial. No invierta dinero que no pueda permitirse perder. Los
        resultados pasados no garantizan resultados futuros.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-110">
        4. Producto Digital - No Reembolsable
      </h4>
      <p data-id="element-111">
        Debido a la naturaleza digital del producto y su entrega inmediata,
        todas las ventas son finales. No se ofrecen reembolsos una vez que el
        producto ha sido entregado y descargado.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-112">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-113">
        Todo el contenido incluido en el producto digital (textos, gráficos,
        estrategias, metodologías) está protegido por derechos de autor. Queda
        prohibida su reproducción, distribución o reventa sin autorización
        expresa por escrito.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-114">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-115">
        En ningún caso seremos responsables por pérdidas financieras, daños
        directos, indirectos, incidentales o consecuentes que resulten del uso o
        la incapacidad de usar la información proporcionada en nuestros
        productos educativos.
      </p>

      <h4 className="font-heading text-lg text-white" data-id="element-116">7. Modificaciones</h4>
      <p data-id="element-117">
        Nos reservamos el derecho de modificar estos Términos y Condiciones en
        cualquier momento. Las modificaciones entrarán en vigor inmediatamente
        después de su publicación en el sitio web.
      </p>
    </>;
}